import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-account\"><path d=\"M20.487 10.488a4.49 4.49 0 1 0-8.978.002 4.49 4.49 0 0 0 8.978-.002Zm1.5 0a5.99 5.99 0 1 1-11.979 0 5.99 5.99 0 0 1 11.98 0Zm2.263 15.567c0-3.504-3.547-6.584-8.25-6.584-4.703 0-8.25 3.08-8.25 6.584v.75h-1.5v-.75c0-4.606 4.52-8.084 9.75-8.084s9.75 3.478 9.75 8.084v.75h-1.5v-.75Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol